(function (w, d) {
    if (w.SlickCDN && w.SlickCDN.ensure) return;

    var CDN = {
        jquery: "https://cdn.jsdelivr.net/npm/jquery@3.7.1/dist/jquery.min.js",
        slickCss: "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css",
        slickThemeCss: "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css",
        slickJs: "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js"
    };

    function loadScript(src) {
        return new Promise(function (resolve, reject) {
            if (d.querySelector('script[src="' + src + '"]')) return resolve();
            var s = d.createElement("script");
            s.src = src;
            s.async = true;
            s.onload = resolve;
            s.onerror = reject;
            d.head.appendChild(s);
        });
    }

    function loadStyle(href) {
        return new Promise(function (resolve, reject) {
            if (d.querySelector('link[rel="stylesheet"][href="' + href + '"]')) return resolve();
            var l = d.createElement("link");
            l.rel = "stylesheet";
            l.href = href;
            l.onload = resolve;
            l.onerror = reject;
            d.head.appendChild(l);
        });
    }

    function ensureJQ() {
        if (w.jQuery) return Promise.resolve(w.jQuery);
        return loadScript(CDN.jquery).then(function () { return w.jQuery; });
    }

    function ensureSlick($) {
        var css = Promise.all([
            loadStyle(CDN.slickCss),
            loadStyle(CDN.slickThemeCss)
        ]);

        var js = ($ && $.fn && typeof $.fn.slick === "function")
            ? Promise.resolve()
            : loadScript(CDN.slickJs);

        return css.then(function () { return js; });
    }

    w.SlickCDN = {
        ensure: function () {
            return ensureJQ().then(function ($) {
                return ensureSlick($).then(function () { return $; });
            });
        }
    };
})(window, document);
